import type { Geometry } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

const OTHER_POLYGON_COLOR = 'hsl(300, 76%, 72%)'

export type OtherPolygonToCreate = {
  properties: { name: string }
  geometry: Geometry
}

// POST /v1/otherPolygons answers the raw upserted row, not a {payload} envelope.
export const createOtherPolygon = async ({
  farmId,
  feature,
}: {
  farmId: string
  feature: OtherPolygonToCreate
}): Promise<void> => {
  const response = await apiClient.post(endpoints.otherPolygons, {
    name: feature.properties.name,
    farmId,
    geometry: feature.geometry,
    color: OTHER_POLYGON_COLOR,
  })
  return unwrapVoid(response)
}
